import { render, staticRenderFns } from "./RegisterBanner.vue?vue&type=template&id=9f4943f4&"
import script from "./RegisterBanner.vue?vue&type=script&lang=js&"
export * from "./RegisterBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports